import React from "react";
import RoleForm from "./RoleForm";

const EditRoleModal = (props) => {
  return <RoleForm {...props} title="Edit Role" type="edit" />;
};

export default EditRoleModal;